// Flame-graph / waterfall view of one trace — `/traces/:traceId`. Every
// span of the trace on a shared time axis + a click-to-inspect span panel
// (model, tokens, cost, input/output payloads).
import { createFileRoute } from '@tanstack/react-router';

import { TraceDetailPage } from '../../components/traces/TraceDetailPage';

function TraceDetailRoute() {
  const { traceId } = Route.useParams();
  return <TraceDetailPage traceId={traceId} />;
}

export const Route = createFileRoute('/traces/$traceId')({ component: TraceDetailRoute });
